import { environment } from '../../../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').factory('ClientProfileSeasonService', ClientProfileSeasonService);

  ClientProfileSeasonService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
  ];

  function ClientProfileSeasonService(RestResource, config, $translate, $filter, UtilService) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'client_profiles';

    var service = {
      getClientProfileSeason: getClientProfileSeason,
      saveClientProfileSeason: saveClientProfileSeason,
      changeClientProfileSeasonStatus: changeClientProfileSeasonStatus,
      deleteClientProfileSeason: deleteClientProfileSeason,
      setGeneralSettings: setGeneralSettings,
      saveGeneralSettings: saveGeneralSettings,
      groupGeneralSettingsByPriceList: groupGeneralSettingsByPriceList,
    };

    return service;

    ////////////////

    function getClientProfileSeason(clientProfileSeason, clientProfileId) {
      var url =
        apiUrl + '/' + clientProfileId + '/client_profile_seasons/' + clientProfileSeason.id;

      return RestResource.request(
        'get',
        url,
        {},
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveClientProfileSeason(clientProfileSeason, clientProfileId) {
      var url = apiUrl + '/' + clientProfileId + '/client_profile_seasons';

      var method = clientProfileSeason.id ? 'put' : 'post';
      url = clientProfileSeason.id ? url + '/' + clientProfileSeason.id : url;

      function success(response) {
        var msg = !clientProfileSeason.id
          ? $translate('CLIENT_PROFILE_SEASON_ADDED')
          : $translate('CLIENT_PROFILE_SEASON_MODIFIED');
        utils._successMsg(msg);

        return response.data;
      }

      function failure(response) {
        utils._errorMsg(response.data.error);

        return false;
      }

      return RestResource.request(
        method,
        url,
        { client_profile_season: clientProfileSeason },
        success,
        failure
      );
    }

    function changeClientProfileSeasonStatus(clientProfileSeason, clientProfileId) {
      var url =
        apiUrl + '/' + clientProfileId + '/client_profile_seasons/' + clientProfileSeason.id;

      var params = { title: null, body: null, successMsg: null };

      if (clientProfileSeason.status === config.ACTIVE) {
        params.title = 'DEACTIVATE_CLIENT_PROFILE_SEASON';
        params.body = 'DEACTIVATING_CLIENT_PROFILE_SEASON_WARNING';
        params.successMsg = 'CLIENT_PROFILE_SEASON_MODIFIED';
      }

      utils.changeItemStatus(url, clientProfileSeason, params);
    }

    function deleteClientProfileSeason(
      clientProfileSeason,
      clientProfileId,
      successCallback,
      index
    ) {
      var url =
        apiUrl + '/' + clientProfileId + '/client_profile_seasons/' + clientProfileSeason.id;

      var params = {
        title: 'SURE_TO_DELETE_CLIENT_PROFILE_SEASON',
        body: 'DELETING_CLIENT_PROFILE_SEASON_WARNING',
        reason: 'DELETE_ITEM_REASON',
        successMsg: 'CLIENT_PROFILE_SEASON_DELETED',
      };

      utils.deleteItem(url, successCallback, params, index);
    }

    function setGeneralSettings(clientProfileGeneralSettings, priceLists) {
      var generalOptions = [
        {
          name: $translate('ALL_PRODUCT_TYPES'),
          icon: 'tag',
          percentage_type: 'general_percentage',
          min: 0,
          max: 100,
        },
        {
          name: $translate('TOUR'),
          icon: 'binoculars',
          percentage_type: 'tour_percentage',
          min: 0,
          max: 100,
        },
        {
          name: $translate('TRANSPORTATION'),
          icon: 'truck',
          percentage_type: 'transportation_percentage',
          min: 0,
          max: 100,
        },
        {
          name: $translate('HOTEL'),
          icon: 'building',
          percentage_type: 'hotel_percentage',
          min: 0,
          max: 100,
        },
        {
          name: $translate('PACKAGE'),
          icon: 'suitcase',
          percentage_type: 'package_percentage',
          min: 0,
          max: 100,
        },
      ];

      clientProfileGeneralSettings = clientProfileGeneralSettings || [];

      var generalSettings = [];
      generalOptions.forEach(function (generalOption) {
        var settingsByPriceList = [];

        priceLists.forEach(function (priceList) {
          var settingId;
          var percentage = 0;

          for (var i = 0; i < clientProfileGeneralSettings.length; i++) {
            var generalSetting = clientProfileGeneralSettings[i];

            if (generalSetting.price_list_id === priceList.id) {
              settingId = generalSetting.id;
              percentage = generalSetting[generalOption.percentage_type];
              break;
            }
          }

          var priceListSetting = {
            percentage_type: generalOption.percentage_type,
            min: generalOption.min,
            max: generalOption.max,
            price_list_id: priceList.id,
            id: null,
          };

          priceListSetting[generalOption.percentage_type] = percentage;

          // Exists
          if (settingId) {
            priceListSetting.id = settingId;
          }

          settingsByPriceList.push(priceListSetting);
        });

        var setting = {
          name: generalOption.name,
          icon: generalOption.icon,
          settingsByPriceList: settingsByPriceList,
        };

        generalSettings.push(setting);
      });

      return generalSettings;

      //vm.generalSettingsCopy = angular.copy(vm.generalSettings);
    }

    function saveGeneralSettings(generalSettings, clientProfileId, clientProfileSeasonId) {
      var url = apiUrl + '/' + clientProfileId + '/client_profile_seasons/' + clientProfileSeasonId;
      url += '/client_profile_general_settings/update_settings';

      function success(response) {
        utils._successMsg($translate('DISCOUNTS_UPDATED'));

        return response.data;
      }
      function failure(response) {
        utils._errorMsg(response.data.error);

        return false;
      }

      return RestResource.request(
        'put',
        url,
        { general_settings: generalSettings },
        success,
        failure
      );
    }

    // In case whe want to save in bulk (embeds_many)
    function groupGeneralSettingsByPriceList(generalSettings) {
      var settingsByPriceList = [];

      generalSettings.forEach(function (generalSetting) {
        var identifier;
        generalSetting.settingsByPriceList.forEach(function (priceListSetting) {
          identifier = priceListSetting.price_list_id;

          if (!settingsByPriceList[identifier]) {
            settingsByPriceList[identifier] = {
              price_list_id: priceListSetting.price_list_id,
            };

            if (priceListSetting.id) {
              settingsByPriceList[identifier].id = priceListSetting.id;
            }
          }

          settingsByPriceList[identifier][priceListSetting.percentage_type] =
            priceListSetting[priceListSetting.percentage_type];
        });
      });

      return utils.removeKeyFromArrayObject(settingsByPriceList);
    }
  }
})();
